export const getWidth = () => {
    return window.innerWidth;
};
export const getHeight = () => {
    return window.innerHeight;
};
